import gsap from "gsap";

const animationMap = new WeakMap();
const observerMap = new WeakMap();
const resizeHandlerMap = new WeakMap();
const distanceMap = new WeakMap();

export const initRollingContent = (blockSelector = ".rolling-content") => {
	const rollingRootEls = document.querySelectorAll(blockSelector);
	rollingRootEls.forEach((rollingRootEl) => {
		if (rollingRootEl.getAttribute("data-initialized") === "true") return;
		// if (rollingRootEl.getAttribute("data-scroll-direction") === "none") return;

		const directionAttr = rollingRootEl.getAttribute("data-scroll-direction");
		const direction = directionAttr === "left" ? 1 : -1;

		rollingRootEl.setAttribute("data-initialized", "true");
		if (directionAttr !== "none") {
			setupIntersectionObserver(rollingRootEl);
		}

		const rcContainer = rollingRootEl.querySelector(".rolling-content-container");
		if (!rcContainer) return;

		// clone and calculate distance once
		const distanceToNextClone = calculateTranslateDistance(rcContainer);
		distanceMap.set(rollingRootEl, distanceToNextClone);

		// set justify-content before cloning
		rcContainer.style.justifyContent = direction === -1 ? "flex-end" : "flex-start";

		const resizeHandler = () => {
			const animation = animationMap.get(rollingRootEl);
			if (animation) {
				gsap.killTweensOf(rcContainer);
				animationMap.delete(rollingRootEl);
				if (isElementInView(rollingRootEl) && rollingRootEl.getAttribute("data-scroll-direction") !== "none") {
					const newAnim = animateRollingContentLayer(rollingRootEl);
					animationMap.set(rollingRootEl, newAnim);
				}
			}
		};
		window.addEventListener("resize", resizeHandler);
		resizeHandlerMap.set(rollingRootEl, resizeHandler);
	});
};

const setupIntersectionObserver = (element) => {
	const options = {
		root: null,
		rootMargin: "50px",
		threshold: 0.1,
	};
	const container = element.querySelector(".rolling-content-container");

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const anim = animationMap.get(element);
			if (entry.isIntersecting) {
				if (anim) {
					anim.play();
				} else {
					const newAnim = animateRollingContentLayer(element);
					animationMap.set(element, newAnim);
				}
			} else {
				if (anim) {
					anim.pause();
				}
			}
		});
	}, options);

	observer.observe(element);
	observerMap.set(element, observer);
};

const isElementInView = (element) => {
	const rect = element.getBoundingClientRect();
	const windowHeight = window.innerHeight || document.documentElement.clientHeight;
	const windowWidth = window.innerWidth || document.documentElement.clientWidth;
	return rect.top < windowHeight + 50 && rect.bottom > -50 && rect.left < windowWidth && rect.right > 0;
};

const animateRollingContentLayer = (rollingRootEl = null) => {
	if (!rollingRootEl) return;
	const rcContainer = rollingRootEl.querySelector(".rolling-content-container");
	if (!rcContainer) return;

	gsap.set(rcContainer, { x: 0 });

	const directionAttr = rollingRootEl.getAttribute("data-scroll-direction");
	const direction = directionAttr === "left" ? 1 : -1;
	const distanceToNextClone = distanceMap.get(rollingRootEl);
	const scrollSpeed = rollingRootEl.getAttribute("data-scroll-speed")
		? parseFloat(rollingRootEl.getAttribute("data-scroll-speed"))
		: 100; // default speed (pixels per second)
	const minSpeed = 1;
	const effectiveSpeed = Math.max(scrollSpeed, minSpeed);

	const duration = distanceToNextClone / effectiveSpeed;

	const animation = gsap.to(rcContainer, {
		x: direction * -distanceToNextClone,
		duration: duration,
		ease: "none",
		repeat: -1,
		force3D: true,
		modifiers: {
			x: gsap.utils.unitize((x) => parseFloat(x) % distanceToNextClone),
		},
	});

	return animation;
};

const ensureEnoughContent = (containerEl) => {
	const originalChildren = Array.from(containerEl.children);
	const containerWidth = containerEl.offsetWidth;
	if (containerWidth === 0 || originalChildren.length === 0) return;

	let cloneCount = 0;
	const maxClones = 20; // Prevent infinite loop

	while (containerEl.scrollWidth < containerWidth * 2 && cloneCount < maxClones) {
		originalChildren.forEach((child) => {
			containerEl.appendChild(child.cloneNode(true));
		});
		cloneCount++;
	}
};

// const calculateTranslateDistance = (containerEl) => {
// 	ensureEnoughContent(containerEl);
// 	const containerElements = containerEl.children;
// 	if (containerElements.length === 0) return 0;
// 	const originalCount = Math.floor(containerElements.length / 2);
// 	return containerElements[originalCount].offsetLeft;
// };

// const calculateTranslateDistance = (containerEl) => {
// 	ensureEnoughContent(containerEl);
// 	const containerElements = containerEl.children;
// 	if (containerElements.length === 0) return 0;
// 	const originalCount = Math.floor(containerElements.length / 2);
// 	let distance = 0;
// 	for (let i = 0; i < originalCount; i++) {
// 		distance += containerElements[i].offsetWidth;
// 	}
// 	return distance;
// };

const calculateTranslateDistance = (containerEl) => {
	const originalChildren = Array.from(containerEl.children);
	const originalCount = originalChildren.length;

	ensureEnoughContent(containerEl);

	let distance = 0;
	for (let i = 0; i < originalCount; i++) {
		distance += originalChildren[i].offsetWidth;
	}
	return distance;
};

// Cleanup function
export const cleanupRollingContentLayer = (rollingRootEl) => {
	const observer = observerMap.get(rollingRootEl);
	if (observer) {
		observer.disconnect();
		observerMap.delete(rollingRootEl);
	}
	const resizeHandler = resizeHandlerMap.get(rollingRootEl);
	if (resizeHandler) {
		window.removeEventListener("resize", resizeHandler);
		resizeHandlerMap.delete(rollingRootEl);
	}
	const animation = animationMap.get(rollingRootEl);
	if (animation) {
		gsap.killTweensOf(rollingRootEl.querySelector(".rolling-content-container"));
		animationMap.delete(rollingRootEl);
	}
	rollingRootEl.setAttribute("data-initialized", "false");
};
